import UHC18 from './UHC18';
import PPT18 from './PPT18';
import MV18 from './MV18';

export default {
  MV18,
  UHC18,
  PPT18
};



// WEBPACK FOOTER //
// ./routes/Checkout/components/Upsell/components/index.jsx